import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle, RefreshCw, MessageCircle, ArrowLeft } from "lucide-react";

export default function PaymentFailurePage() {
  const [searchParams] = useSearchParams();
  const transactionRef = searchParams.get("ref");
  const reason = searchParams.get("reason");

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Card className="text-center">
          <CardContent className="pt-12 pb-8 px-8">
            {/* Failure Icon */}
            <div className="w-20 h-20 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-12 h-12 text-destructive" />
            </div>

            <h1 className="font-heading text-3xl font-bold mb-2" data-testid="failure-title">
              Payment Failed
            </h1>
            <p className="text-muted-foreground mb-8">
              We couldn't process your payment. Don't worry, you haven't been charged.
            </p>

            {/* Error Details */}
            {(transactionRef || reason) && (
              <div className="bg-destructive/5 border border-destructive/20 rounded-xl p-6 text-left mb-8">
                {transactionRef && (
                  <div className="flex justify-between mb-2">
                    <span className="text-muted-foreground">Transaction Reference</span>
                    <span className="font-mono">{transactionRef}</span>
                  </div>
                )}
                {reason && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Reason</span>
                    <span className="text-destructive">{reason}</span>
                  </div>
                )}
              </div>
            )}

            {/* Common Reasons */}
            <div className="bg-secondary/50 rounded-xl p-6 text-left mb-8">
              <h3 className="font-medium mb-3">Common reasons for payment failure:</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>• Insufficient balance in your mobile money wallet</li>
                <li>• Incorrect PIN entered</li>
                <li>• Network connectivity issues</li>
                <li>• Transaction timeout</li>
                <li>• Daily transaction limit exceeded</li>
              </ul>
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild className="bg-primary">
                <Link to="/checkout">
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Try Again
                </Link>
              </Button>
              <Button asChild variant="outline">
                <a href="https://wa.me/233501234567" target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="w-4 h-4 mr-2" />
                  Contact Support
                </a>
              </Button>
            </div>

            <div className="mt-8">
              <Link to="/mock-exams" className="text-sm text-muted-foreground hover:text-primary inline-flex items-center">
                <ArrowLeft className="w-4 h-4 mr-1" />
                Back to Shop
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
